import { useRecoilValue } from 'recoil';
import { isMobileState } from '@/store/atom';
import { useAppSelector } from '@/redux/store';

import { ChatbotResponseItem } from '@/api';
import { useRecoilState } from 'recoil';
import { aiChatBotSessionIdState } from '@/store/atom';
import { queryChatbotAPI } from '@/api';
import { useChatbotContext } from '@/pages/Lab/_context/ChatbotContext';
import { Message } from '@/types/discover';
import { AxiosError } from 'axios';

export const useGetAIChatbotAnswer = () => {
  const isMobile = useRecoilValue(isMobileState);
  const user = useAppSelector((state) => state.user);
  const [sessionId, setSessionId] = useRecoilState(aiChatBotSessionIdState);
  const {
    messages,
    setMessages,
    setIsLoading,

    setIsThinking,
    isLoading,
    createNewAbortController,
  } = useChatbotContext();

  const getAiChatBotAnswer = async ({
    messageText,
    skipMessageSave = false,
    action = '',
    propsSessionId,
    superChat = false,
  }: {
    messageText: string;
    skipMessageSave?: boolean;
    action?: string;
    propsSessionId?: string;
    superChat?: boolean;
  }) => {
    if (isLoading) return;
    let errorCode: number | undefined;
    let response: ChatbotResponseItem | undefined;

    const requestPayload = {
      seller_id: user.UserNo,
      input_text: messageText,
      user_action: action || null,
      platform: isMobile ? ('APP' as const) : ('WEB' as const),
      // session_id: skipMessageSave ? '' : sessionId ?? '',
      session_id: skipMessageSave
        ? ''
        : propsSessionId
        ? propsSessionId
        : sessionId
        ? sessionId
        : '',
      guid: user.CplatToken,
    };

    try {
      !skipMessageSave ? setIsLoading(true) : setIsThinking(true);
      // const signal = createNewAbortController(); // 새 컨트롤러 만들고 signal 받기
      const signal = superChat ? undefined : createNewAbortController();
      response = await queryChatbotAPI(requestPayload, signal);

      setSessionId(response.session_id);

      if (skipMessageSave) {
        setMessages((prevMessages) => {
          if (prevMessages.length === 0) return prevMessages;

          const lastMessage = prevMessages[prevMessages.length - 1];

          return [
            ...prevMessages.slice(0, -1),
            {
              ...lastMessage,
              sessionId: response!.session_id,
              maxQuestionCount: response!.max_question_count,
              questionRemainCount: response!.question_remain_count,
            },
          ];
        });
      } else {
        const botMessage: Message = {
          id: Date.now() + 1,
          text: response.response,
          sender: 'bot',
          maxQuestionCount: response.max_question_count,
          questionRemainCount: response.question_remain_count,
          sessionId: propsSessionId || response.session_id,
        };
        setMessages((prev) => [...prev, botMessage]);
      }
    } catch (error: unknown) {
      const errorMessage = (error as AxiosError).message;
      errorCode = Number((error as { code?: string | number }).code);
      const lastBotMessage = [...messages].reverse().find((msg) => msg.sender === 'bot');

      if (errorCode === 1234) return;
      console.error('Error fetching AI response:', error);

      setMessages((prev) => [
        ...prev,
        {
          id: Date.now() + 1,
          text: errorMessage,
          sender: 'bot',
          errorCode,
          sessionId: sessionId,
          maxQuestionCount: lastBotMessage?.maxQuestionCount ?? 9999,
          questionRemainCount: lastBotMessage?.questionRemainCount ?? 9999,
        },
      ]);
    } finally {
      !skipMessageSave ? setIsLoading(false) : setIsThinking(false);

      // const logParams = {
      //   user_id: user.UserNo,
      //   session_id: response?.session_id || sessionId,
      //   input: skipMessageSave ? 'chatInit' : messageText,
      //   user_action: action || '',
      //   platform: isMobile ? 'APP' : 'WEB',
      //   guid: user.CplatToken,
      //   error_code: errorCode || null, // 성공 시 null
      // };
    }
    return response!;
  };
  return { getAiChatBotAnswer };
};
